<template>
    <div class="eventManage_jsjb statisticalAnalysis">
        <div class="statisticalAnalysis_form">
            <div class="statisticalAnalysis_form_left">
                <el-date-picker
                    v-model="daterange"
                    type="daterange"
                    range-separator="至"
                    value-format="YYYY-MM-DD"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
            </div>
        </div>
        <div class="statisticalAnalysis_table">
            <div class="tableComponent" style="width: 100%">
                <!--:max-height="tableMaxheight"-->
                <el-table lazy :data="tableArray" :max-height="tableMaxheight" scrollbar-always-on="true"
                          style="width: 100%">
                    <el-table-column type="index" align="center" label="序号" width="100">
                        <template #default="scope">{{ (formSearch.pageNum-1)*formSearch.pageSize + scope.$index+1 }}</template>
                    </el-table-column>
                    <el-table-column prop="time" label="打卡时间" min-width="40%" />
                    <el-table-column prop="dkdz" label="打卡地址" min-width="60%" />
                </el-table>
            </div>
            <div class="jsjb_button">
                <div class="jsjb_button_list" @click="extExcel">
                    <i class="icon-file-excel"></i>导出
                </div>
                <div class="statisticalAnalysis_buttonPage">
                    <el-pagination
                        v-model:page-size="pageSize"
                        :page-sizes="[50, 100,150, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="rowsCount"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {reactive, onMounted, ref, watch, getCurrentInstance, nextTick} from 'vue'
    import {Search} from '@element-plus/icons-vue'
    import {useStore} from 'vuex'
    import {useRoute} from 'vue-router'

    export default {
        name: "ViewStatisticalAnalysis",
        props:["parentToChild"],
        setup(props,content) {
            const {proxy} = getCurrentInstance();
            const store = useStore();
            let route = useRoute();
            //搜索条件
            let daterange = ref([])
            let formSearch = reactive({
                userid : props.parentToChild.userid,
                startTime : "",
                endTime : "",
                pageNum : 1,
                pageSize : 10,
            })
            watch(() => daterange.value, (newVal) => {
                if (newVal) {
                    formSearch.startTime = newVal[0]
                    formSearch.endTime = newVal[1]
                } else {
                    formSearch.startTime = ""
                    formSearch.endTime = ""
                }
                tableData()
            })
            //表格
            let tableArray = ref()
            let tableMaxheight = ref()
            //计算表格最大高度
            const tableMaxheightFun = () => {
                setTimeout(() => {
                    const clientHeight = document.documentElement.clientHeight;
                    const clientWidth = document.documentElement.clientWidth
                    tableMaxheight.value = clientHeight - (48 + 48 + 36 + 56) * clientWidth / 1920;
                }, 0)
            }
            //分页
            let rowsCount = ref();
            const handleSizeChange =(param)=>{
                formSearch.pageSize = param
                tableData()
            }
            const handleCurrentChange=(param)=>{
                formSearch.pageNum = param
                tableData()
            }
            //查询表格数据
            const tableData =()=>{
                proxy.$axios.post("/jgfast/wgsj/selWgsjClockinGrXq",formSearch ).then((res) => {
                    tableArray.value = res.data.vbs;
                    rowsCount.value = res.data.rowsCount
                });
            }
            //默认时间
            const defaultTime = ()=>{
                let time1 = new Date();
                let year = time1.getFullYear();
                let month = (time1.getMonth()+1)<10?"0"+(time1.getMonth()+1):(time1.getMonth()+1);
                let day1 = time1.getDate()<10?"0"+time1.getDate():time1.getDate();
                // let hour = time1.getHours()<10?"0"+time1.getHours():time1.getHours(); //得到小时
                // let minu = time1.getMinutes()<10?"0"+time1.getMinutes():time1.getMinutes(); //得到分钟
                let datetimerange1 = year+"-"+month+"-"+day1
                let time2  = new Date();
                time2.setTime(time1.getTime() - 3600 * 24*1000);
                let day2 = time2.getDate()<10?"0"+time2.getDate():time2.getDate();
                let datetimerange2 =year+"-"+month+"-"+day2
                daterange.value[0] = datetimerange2;
                daterange.value[1] = datetimerange1;
                formSearch.startTime = datetimerange2
                formSearch.endTime = datetimerange1;
            }
            //导出excel
            const extExcel = () => {
                // proxy.$axios.own.get("/jgfast/wgsj/sysName").then(res => {console.log(res.data)})

                // var params = Object.assign({_u:"fast-wgsjlb.xml"}, formSearch);
                var params = {
                    _u:"fast-wgsjlb.xml",
                    gdCjsj_end:formSearch.gdCjsj_end,
                    gdCjsj_start:formSearch.gdCjsj_start,
                    query_jjcs:formSearch.query_jjcs,
                    query_yjcs:formSearch.query_yjcs,
                    search:formSearch.search,
                    tzlx:formSearch.tzlx,
                }
                proxy.$axios.own.get('/jgfast/ureport/excel?'+qs.stringify(params),{
                    // params: params,
                    responseType: 'blob'   //首先设置responseType字段格式为 blob
                }).then(res => {
                    let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}); // 为blob设置文件类型，这里以.xlsx为例
                    let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = '网格事件列表.xlsx';
                    a.click();
                    // 释放这个临时的对象url
                    window.URL.revokeObjectURL(url);
                });
            }
            onMounted(() => {
                tableMaxheightFun()
                defaultTime()
                window.addEventListener('resize', () =>tableMaxheightFun() , true);
                tableData()
            });
            //分
            return {
                formSearch,
                Search,
                daterange,
                rowsCount,
                tableArray,
                handleSizeChange,
                handleCurrentChange,
                tableMaxheight,
                extExcel
            }
        }
    }
</script>

<style scoped>

</style>
